import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { ShiftSection } from '../components/ShiftSection';
import { BreakthroughSection } from '../components/BreakthroughSection';
import { DeclarationSection } from '../components/DeclarationSection';
export function HomePage() {
  return <div style={{
    backgroundColor: 'var(--black)',
    width: '100%',
    minHeight: '100vh'
  }} data-id="element-476">
      <Navigation data-id="element-477" />
      <main data-id="element-478">
        <HeroSection data-id="element-479" />
        <ProblemSection data-id="element-480" />
        <ShiftSection data-id="element-481" />
        <BreakthroughSection data-id="element-482" />
        <DeclarationSection data-id="element-483" />
      </main>
    </div>;
}